document.addEventListener("DOMContentLoaded", function() {
  const reviewBodies = document.querySelectorAll(".jdgm-carousel-item__review-body");

  reviewBodies.forEach(function(body) {
    const img = document.createElement("img");
    img.src = "https://cdn.shopify.com/s/files/1/0824/3498/2181/files/testimonials-quote-icon.png?v=1770283307"; 
    img.alt = "Your Alt Text";
    img.style.width = "40px";
    img.style.marginBottom = "10px";

    body.parentNode.insertBefore(img, body);
  });
});

